module.exports = __webpack_public_path__ + "static/media/application.22710f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/application.png
// module id = 823
// module chunks = 0